import { combineReducers } from '@reduxjs/toolkit'

import type { CreateReducer } from 'redux/utils'
import { paginationReducer } from 'redux/pagination'
import { sortingReducer } from 'redux/sorting'
import { filterReducer } from 'redux/filter'

export const gridPaginationName = (sliceName: string) => `${sliceName}/pagination`
export const gridSortingName = (sliceName: string) => `${sliceName}/sorting`
export const gridFilterName = (sliceName: string) => `${sliceName}/filter`

export const dataGridReducer: CreateReducer<any> = sliceName => {
  return combineReducers({
    pagination: paginationReducer(gridPaginationName(sliceName)),
    sorting: sortingReducer(gridSortingName(sliceName)),
    filter: filterReducer(gridFilterName(sliceName)),
  })
}
